<template>
  <div class="overflow-auto ts-max-h-40" style="min-height: 150px;">
    <div class="table-ui-detail">
      <table>
        <thead>
          <tr>
            <th width="1%" class="ts-text-center">
              {{ $t('no') }}
            </th>
            <th width="17%">
              {{ $t('approvalRequestFlow.levelOrder') }}
              <span class="ts-text-red-600">*</span>
            </th>
            <th width="20%">
              {{ $t('approvalRequestFlow.approverType') }}
              <span class="ts-text-red-600">*</span>
            </th>
            <th width="20%">
              {{ $t('approvalRequestFlow.approver') }}
              <span class="ts-text-red-600">*</span>
            </th>
            <th width="20%">
              {{ $t('approvalRequestFlow.approverTypeCc') }}
            </th>
            <th width="20%" class="ts-text-center">
              {{ $t('approvalRequestFlow.approverCc') }}
            </th>
            <th class="text-center ts-fixed ts-right-0" width="2%">
              <a href="#" class="tw-text-white" @click.prevent="addNew">
                <i class="fas fa-plus"></i>
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="model.details.length == 0">
            <td colspan="7" class="ts-text-center ts-p-3 ts-space-x-1">
              <i class="fa fa-folder-open ts-text-gray-200"></i>
              <label class="ts-text-gray-400">
                {{ $t('noData') }}
              </label>
              <div class="validate ts-text-left" v-if="errors.has('details')">
                {{ errors.first('details') }}
              </div>
            </td>
          </tr>
          <tr v-else v-for="(detail, index) in model.details" :key="index">
            <td class="ts-whitespace-no-wrap ts-text-center">
              {{ index + 1 }}
            </td>
            <td class="ts-overflow-hidden ts-whitespace-no-wrap" style="max-width: 200px;min-width: 100px;">
              <input v-model.number="detail.level_order" style="min-width: 60px;" type="number" class="form-control"
                :class="{
                  'is-invalid': errors.has('details.' + index + '.level_order')
                }" />
            </td>
            <td class="ts-whitespace-no-wrap ts-overflow-hidden" style="max-width: 165px;min-width: 100px;">
              <a-select v-model="detail.approver_type_id" :options="approverTypesOptions" option-filter-prop="children"
                class="ts-w-full" :class="{
                  'is-invalid': errors.has('details.' + index + '.approver_type_id')
                }" placeholder="Select" style="min-width: 75px;"
                @change="() => detail.approver_type_value = undefined"></a-select>
            </td>
            <td class="ts-whitespace-no-wrap ts-overflow-hidden" style="max-width: 165px;min-width: 100px;">
              <a-select v-if="detail.approver_type_id == 1" v-model="detail.approver_type_value" :options="userOptions"
                :placeholder="$t('approvalRequestFlow.user')" class="ts-w-full" :class="{
                  'is-invalid': errors.has('details.' + index + '.approver_type_value')
                }" allowClear show-search option-filter-prop="children">
              </a-select>
              <a-select v-else-if="detail.approver_type_id == 2" v-model="detail.approver_type_value"
                :options="roleOptions" :placeholder="$t('approvalRequestFlow.mobileRole')" class="ts-w-full" :class="{
                  'is-invalid': errors.has('details.' + index + '.approver_type_value')
                }" allowClear show-search option-filter-prop="children">
              </a-select>
              <a-select v-else class="ts-w-full" v-model="detail.approver_type_value" :options="userOptions" disabled
                :placeholder="$t('select')">
              </a-select>
            </td>
            <td class="text-center ts-whitespace-no-wrap">
              <a-select v-model="detail.approver_type_cc_id" :options="approverTypesOptions"
                option-filter-prop="children" class="ts-w-full" placeholder="Select" style="min-width: 75px;"
                @change="() => detail.approver_type_cc_value = undefined"></a-select>
            </td>
            <td class="text-center ts-whitespace-no-wrap">
              <a-select v-if="detail.approver_type_cc_id == 1" v-model="detail.approver_type_cc_value"
                :options="userOptions" :placeholder="$t('approvalRequestFlow.user')" class="ts-w-full" allowClear
                show-search option-filter-prop="children">
              </a-select>
              <a-select v-else-if="detail.approver_type_cc_id == 2" v-model="detail.approver_type_cc_value"
                :options="roleOptions" :placeholder="$t('approvalRequestFlow.mobileRole')" class="ts-w-full" allowClear
                show-search option-filter-prop="children">
              </a-select>
              <a-select v-else class="ts-w-full" v-model="detail.approver_type_cc_value" :options="userOptions" disabled
                :placeholder="$t('select')">
              </a-select>
            </td>
            <td class="text-center ts-sticky ts-right-0" style="background: #f7f7f7;">
              <Tooltip placement="top" :transfer="true" :content="$t('remove')">
                <a href="#" class="text-danger" @click.prevent="destroy(detail)">
                  <Icon type="ios-remove-circle-outline" size="20" />
                </a>
              </Tooltip>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import TableProgressBar from '@/components/common/TsTable/TableProgressBar'

export default {
  name: 'approval-flow-detail',
  components: { TableProgressBar },
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
      model: {},
      item: {
        id: 0,
        level_order: '',
        approver_type_id: undefined,
        approver_type_value: undefined,
        approver_type_cc_id: undefined,
        approver_type_cc_value: undefined
      },
      loading: false
    }
  },
  created() {
    this.model = this.value
    this.loading = true
    Promise.all([this.fetchUser(), this.fetchMobileRole()]).then(() => {
      this.loading = false
    })
  },

  computed: {
    ...mapState('setting/approvalRequestFlow', ['approverTypes']),
    approverTypesOptions() {
      return this.approverTypes.map(el => ({
        value: el.approver_type_id,
        label: el.approver_type
      }))
    },
    userOptions() {
      return this.$store.state.setting.approvalRequestFlow.users.map(el => ({
        value: el.user_id,
        label: el.name
      }))
    },
    roleOptions() {
      return this.$store.state.setting.approvalRequestFlow.roles.map(el => ({
        value: el.mobile_role_id,
        label: el.role_name + ' => ' + el.description
      }))
    }
  },
  methods: {
    ...mapActions('setting/approvalRequestFlow', [
      'fetchUser',
      'fetchMobileRole'
    ]),
    destroy(detail) {
      this.model.details.splice(this.model.details.indexOf(detail), 1)
    },
    addNew() {
      let item = {
        id: 0,
        level_order: '',
        approver_type_id: undefined,
        approver_type_value: undefined,
        approver_type_cc_id: undefined,
        approver_type_cc_value: undefined
      };

      this.model.details.push(item)
    },
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
<style scoped>
#container-table {
  min-height: 25vh;
  max-height: 40vh;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  z-index: 99;
}

.table>thead>tr>th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 2;
}
</style>